/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OauthCallbackType {
    REFUND_RESOLUTION_SIGN = 'REFUND_RESOLUTION_SIGN',
    REFUND_REJECTION = 'REFUND_REJECTION',
    PASSWORD_RECOVERY = 'PASSWORD_RECOVERY',
    FRAUD_REPORTS = 'FRAUD_REPORTS'
}

